import script from "./ActivatePassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActivatePassword.vue?vue&type=script&lang=ts&setup=true"

import "./ActivatePassword.vue?vue&type=style&index=0&id=dae6d628&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dae6d628"]])

export default __exports__